<div class="wallet-qris-pin-container">
  <div class="wallet-qris-pin-content">
    <p-messages class="paper-message" />
    <img
      src="./assets/images/illust/il-wallet-pin.svg"
      alt="Wallet Activation Illustration"
    />
    <ng-container>
      <h1 class="wallet-qris-pin-title">
        {{ "wallet_trx_pin.title" | translate }}
      </h1>
      <p class="wallet-qris-pin-subtitle">
        {{ "wallet_trx_pin.subtitle" | translate }}
      </p>
    </ng-container>
    <paper-otp
      (onInputChange)="onPinChange($event)"
      [config]="config"
      [is_error]="pinError ? true : false"
      [isDisabled]="pinDisabled"
      [otpReload]="reloadPin"
    ></paper-otp>
    <div *ngIf="pinError" class="mt-20">
      <span [innerHtml]="pinError | translate" class="error-text"></span>
      <div class="mt-20">
        <a [href]="contactCSUrl" target="_blank" noopener noreferrer class="mt-20">
          <strong>{{ "wallet_trx_pin.help" | translate }}</strong>
        </a>
      </div>
    </div>
  </div>
  <div class="sticky-section-container">
    <button 
      type="button" 
      class="paper-button blue-button w-100 mb-64" 
      [class.disabled]="isLoading || !pinAuthKey"
      [disabled]="isLoading || !pinAuthKey"
      (click)="handlePayment()"
      >
      {{ "wallet_qris.pay" | translate }}
      <p-progress-spinner 
        *ngIf="isLoading"
        fill="transparent" 
        animationDuration="1s"
        styleClass="spinner-white" 
        [style]="{ width: '20px', height: '20px' }" />
    </button>
    <div class="certificate-container">
      <img src="./assets/images/wallet-trust-certificate.svg" alt="Wallet Trust Certificate"/> 
    </div> 
  </div>
</div>
<div *ngIf="isPinLocked" class="bottomsheet-overlay">
  <div class="bottomsheet-container">
    <div class="bottomsheet-content">
      <img
      src="./assets/images/illust/il-pin-locked.svg"
      alt="Pin Locked"
    />
    <ng-container>
      <h2>
        {{ "wallet_trx_pin.locked" | translate }}
      </h2>
      <p>
        {{ 'wallet_trx_pin.locked_desc' | translate }}
      </p>
      <div class="d-flex gap-16">
        <button 
          type="button" 
          class="paper-ghost-button blue-button w-100"
          (click)="getHelp()"
          >
          {{ "wallet_trx_pin.action_back_home" | translate }}
        </button>
      </div>
    </ng-container>
    </div>
  </div>
</div>
<div *ngIf="paymentError" class="bottomsheet-overlay">
  <div class="bottomsheet-container">
    <div class="bottomsheet-content">
      <img
      src="./assets/images/illust/il-trx-FAILED.svg"
      alt="Error Payment"
    />
    <ng-container>
      <h2>
        {{ "wallet_trx_pin.failed" | translate }}
      </h2>
      <p>
        {{ 'wallet_trx_pin.failed_desc' | translate: {error_code: paymentErrorCode} }}
      </p>
      <div class="d-flex gap-16">
        <button 
          type="button" 
          class="paper-ghost-button blue-button w-100"
          (click)="getHelp()"
          >
          {{ "wallet_trx_pin.help" | translate }}
        </button>
        <button 
          type="button" 
          class="paper-button blue-button w-100"
          (click)="requestPin()"
          >
          {{ "wallet_trx_pin.retry" | translate }}
        </button>
      </div>
    </ng-container>
    </div>
  </div>
</div>
    